import React, { useState } from "react";
import SaveBadge from "../components/SaveBadge";
import ActionMenu from "../components/ActionMenu";
import { BF, FF } from "../lib/constants";

export default function Home({
  mob, pd, plans, conceptPlans, archivedPlans, dsecs, canEdit,
  canEditRole, viewOnly, setViewOnly,
  showExtra, extraCount, hasDeck, onOpenAccounts,
  openLevel, openEditLevel, confirmDel, openDuplicatePlan, onCopyToLibrary, onOpenWeek, onOpenLibrary, toggleArchive, toggleConcept, moveLevel, openMoveLevel,
  setMdl, setNn, setNc,
  renderModal, savLabel, sav,
  showPublishBanner, publishing, onPublish, justPublished,
}) {
  var [openYears, setOpenYears] = useState([]);

  
  function renderCard(l, idx, arr) {
    var sib = (arr || []).filter(function (x) { return !x.extra; });
    var pos = sib.findIndex(function (x) { return x.id === l.id; });
    var isDrills = l.type === "drills";
    return (
      <div key={l.id} style={{ position: "relative", minWidth: 0, display: "flex" }}>
        <button onClick={function () { openLevel(l); }} style={{ background: "#fff", border: "2px " + (l.concept ? "dashed " : "solid ") + l.border, borderRadius: 16, padding: canEdit && !l.extra ? "14px 52px 14px 18px" : "14px 18px", cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", gap: 12, width: "100%", flex: 1, opacity: l.archived ? .65 : 1 }}>
          {isDrills
            ? <div style={{ width: 26, height: 26, borderRadius: 6, background: l.color, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>🎾</div>
            : <div style={{ width: 26, height: 26, borderRadius: "50%", background: l.color, flexShrink: 0 }} />}
          <div style={{ textAlign: "left", minWidth: 0, flex: 1 }}>
            <span style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", lineHeight: 1.3, overflowWrap: "anywhere", fontFamily: BF, fontSize: 14, color: "#1C1B19", fontWeight: 800 }}>{l.label}</span>
            <span style={{ fontSize: 10, color: "#999" }}>{l.extra ? (extraCount + (extraCount === 1 ? " oefening" : " oefeningen")) : (isDrills ? "Oefeningen" : (l.concept ? "Concept" : "Seizoensplan"))}</span>
          </div>
        </button>
        {canEdit && !l.extra && <ActionMenu center items={[
          { icon: "✎", label: "Naam en kleur aanpassen", onClick: function () { openEditLevel(l.id); } },
          pos > 0 && { icon: "↑", label: "Eerder zetten", onClick: function () { moveLevel(l.id, pos - 1); } },
          pos >= 0 && pos < sib.length - 1 && { icon: "↓", label: "Later zetten", onClick: function () { moveLevel(l.id, pos + 1); } },
          sib.length > 2 && { icon: "⇅", label: "Verplaatsen naar…", onClick: function () { openMoveLevel(l.id); } },
          !isDrills && { icon: "⧉", label: "Dupliceren", onClick: function () { openDuplicatePlan(l.id); } },
          !isDrills && onCopyToLibrary && { icon: "⇢", label: "Kopiëren naar losse lessen", onClick: function () { onCopyToLibrary(l.id); } },
          !isDrills && l.concept && !l.archived && { icon: "✓", label: "Activeren (zichtbaar voor trainers)", onClick: function () { toggleConcept(l.id); } },
          !isDrills && !l.concept && !l.archived && { icon: "📝", label: "Terug naar concept", onClick: function () { toggleConcept(l.id); } },
          !isDrills && !l.concept && !l.archived && { icon: "🗄", label: "Archiveren", onClick: function () { toggleArchive(l.id); } },
          !isDrills && l.archived && { icon: "↩", label: "Terug naar actief", onClick: function () { toggleArchive(l.id); } },
          { icon: "×", label: "Verwijderen", danger: true, onClick: function () { confirmDel("level", l.id); } },
        ]} />}
      </div>
    );
  }

  return (
    <div style={{ minHeight: "calc(100vh - 110px)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", paddingTop: mob ? 24 : 40, paddingLeft: pd, paddingRight: pd, paddingBottom: pd, fontFamily: FF, background: "#F5F3EE" }}>
      <SaveBadge show={sav} label={savLabel} />
      <div style={{ textAlign: "center", marginBottom: mob ? 24 : 32 }}>
        <h1 style={{ fontFamily: BF, fontSize: mob ? 26 : 35, color: "#1C1B19", marginBottom: 4, fontWeight: 800 }}>Kies een groep</h1>
        <p style={{ color: "#6B675F", fontSize: 14, marginBottom: 12 }}>Of kijk verder:</p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, auto))", gap: mob ? 8 : 10, justifyContent: "center" }}>
          {[
            { label: "Weekoverzicht", sub: "Alle groepen van deze week", bg: "#EAF0F7", fg: "#2A4E78", d: ["M3 5h18v15H3z", "M3 10h18", "M8 3v4", "M16 3v4"], onClick: onOpenWeek },
            { label: "Bibliotheek", sub: "Losse lessen en oefeningen", bg: "#E8F5F6", fg: "#1D7F8C", d: ["M4 4h4v16H4z", "M10 4h4v16h-4z", "M16.5 5l3.5 1-3 14-3.5-1z"], onClick: onOpenLibrary },
          ].map(function (b) {
            return (
              <button key={b.label} type="button" onClick={b.onClick}
                style={{ display: "flex", alignItems: "center", gap: mob ? 8 : 12, minHeight: mob ? 52 : 56, padding: mob ? "6px 12px 6px 6px" : "8px 18px 8px 10px", borderRadius: mob ? 12 : 14, border: "1px solid #E6E2D9", background: "#fff", textAlign: "left", cursor: "pointer", fontFamily: FF }}>
                <span style={{ width: mob ? 34 : 38, height: mob ? 34 : 38, borderRadius: mob ? 9 : 10, background: b.bg, color: b.fg, display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                  <svg width={mob ? 18 : 20} height={mob ? 18 : 20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{b.d.map(function (p, i) { return <path key={i} d={p} />; })}</svg>
                </span>
                <span>
                  <span style={{ display: "block", fontSize: mob ? 14 : 15, fontWeight: 800, color: "#1C1B19" }}>{b.label}</span>
                  {!mob && <span style={{ display: "block", fontSize: 12, color: "#6B675F" }}>{b.sub}</span>}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Concept: voor editor/creator altijd zichtbaar (ook leeg), behalve in Bekijkmodus. */}
      {conceptPlans && <p style={{ fontFamily: BF, fontSize: 12, letterSpacing: 1, color: "#999", marginBottom: 8, fontWeight: 700 }}>CONCEPT</p>}
      {conceptPlans && conceptPlans.length > 0 && <div style={{ display: "grid", gap: 10, gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))", maxWidth: mob ? 520 : 760, marginBottom: 24, width: "100%" }}>
        {conceptPlans.map(renderCard)}
      </div>}
      {conceptPlans && conceptPlans.length === 0 && <div style={{ border: "2px dashed #E2DED5", borderRadius: 16, padding: "14px 20px", color: "#AAA49A", fontSize: 12, textAlign: "center", maxWidth: mob ? 520 : 760, width: "100%", marginBottom: 24, lineHeight: 1.5 }}>
        Nog geen concepten. Nieuwe seizoensplannen komen hier eerst te staan; trainers zien ze pas als je ze via ⋯ → Activeren zichtbaar maakt.
      </div>}

      {plans.length > 0 && <p style={{ fontFamily: BF, fontSize: 12, letterSpacing: 1, color: "#999", marginBottom: 8, fontWeight: 700 }}>SEIZOENSPLANNEN</p>}
      {plans.length > 0 && <div style={{ display: "grid", gap: 10, gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))", maxWidth: mob ? 520 : 760, marginBottom: 24, width: "100%" }}>
        {plans.map(renderCard)}
      </div>}

      {/* Archief (build 2.5): per jaar een map die je open- en dichtklapt. */}
      {archivedPlans && archivedPlans.length > 0 && <p style={{ fontFamily: BF, fontSize: 12, letterSpacing: 1, color: "#6B675F", marginBottom: 8, fontWeight: 700 }}>ARCHIEF</p>}
      {archivedPlans && archivedPlans.length > 0 && <div style={{ display: "flex", flexDirection: "column", gap: 10, maxWidth: mob ? 520 : 760, marginBottom: 24, width: "100%" }}>
        {archiveYears(archivedPlans).map(function (g) {
          var open = openYears.indexOf(g.year) >= 0;
          return (
            <div key={g.year} style={{ background: open ? "#FAF8F4" : "transparent", borderRadius: 16, border: open ? "1px solid #E6E2D9" : "1px solid transparent", padding: open ? 10 : 0 }}>
              <button type="button" aria-expanded={open} onClick={function () { setOpenYears(open ? openYears.filter(function (y) { return y !== g.year; }) : openYears.concat([g.year])); }}
                style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", borderRadius: 14, border: "1px solid #E6E2D9", background: "#fff", cursor: "pointer", fontFamily: FF, textAlign: "left", minHeight: 56 }}>
                <span style={{ width: 34, height: 34, borderRadius: 9, background: "#F0EDE6", color: "#6B675F", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true"><path d="M3 6a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" /></svg>
                </span>
                <span style={{ flex: 1 }}>
                  <span style={{ display: "block", fontSize: 15, fontWeight: 800, color: "#1C1B19" }}>{g.year}</span>
                  <span style={{ display: "block", fontSize: 12, color: "#6B675F" }}>{g.plans.length + (g.plans.length === 1 ? " seizoensplan" : " seizoensplannen")}</span>
                </span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6B675F" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .15s" }}><path d="M6 9l6 6 6-6" /></svg>
              </button>
              {open && <div style={{ display: "grid", gap: 10, gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))", marginTop: 10 }}>
                {g.plans.map(function (l, i) { return renderCard(l, i, archivedPlans); })}
              </div>}
            </div>
          );
        })}
      </div>}

      {canEdit && <button onClick={function () { setMdl("addPlan"); setNn(""); setNc(0); }} style={{ background: "#fff", border: "2px dashed #CFC9BD", borderRadius: 16, padding: "16px 28px", cursor: "pointer", display: "flex", alignItems: "center", gap: 10, color: "#999", marginBottom: 20 }}>
        <span style={{ fontSize: 20 }}>+</span><span style={{ fontFamily: BF, fontSize: 12, fontWeight: 800 }}>Toevoegen</span>
      </button>}

      {renderModal()}
    </div>
  );
}

// Jaartal van een (gearchiveerd) plan: het veld `year`, anders uit de naam ("2023" of
// "'23"); lukt dat niet, dan "Overig". Nieuwste jaar bovenaan.
export function planYear(l) {
  if (l.year) return String(l.year);
  var s = String(l.label || "");
  var m = s.match(/\b(20\d{2})\b/);
  if (m) return m[1];
  m = s.match(/['’](\d{2})\b/);
  if (m) return "20" + m[1];
  return "Overig";
}
function archiveYears(list) {
  var groups = {};
  list.forEach(function (l) { var y = planYear(l); (groups[y] = groups[y] || []).push(l); });
  return Object.keys(groups).sort(function (a, b) { return a === "Overig" ? 1 : b === "Overig" ? -1 : Number(b) - Number(a); })
    .map(function (y) { return { year: y, plans: groups[y] }; });
}
